import { render } from "./DataTableBody.vue?vue&type=template&id=7b68ec73&scoped=true&ts=true"
import script from "./DataTableBody.vue?vue&type=script&lang=ts"
export * from "./DataTableBody.vue?vue&type=script&lang=ts"

import "./DataTableBody.vue?vue&type=style&index=0&id=7b68ec73&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b68ec73"]])

export default __exports__